import Phaser from 'phaser';

class Body extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'character_body');

    this.scene.add.existing(this);
  }
}

class Head extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'character_head');

    this.scene.add.existing(this);
  }

  fall({ speed = 100, direction = 'right' } = {}) {
    this.scene.physics.add.existing(this);
    this.body.setCollideWorldBounds(true);
    this.body.setGravityY(200);
    this.body.setVelocity(speed, -20);
    this.body.setBounce(0.25);
    this.body.drag.x = 30;
    this.scene.tweens.add({
      targets: this,
      duration: 1500,
      angle: 130,
      ease: Phaser.Math.Easing.Quadratic.In,
    });
  }
}

class Face extends Phaser.GameObjects.DOMElement {
  constructor(scene, x, y) {
    const img = document.createElement('img');
    img.src = 'https://randomuser.me/api/portraits/men/10.jpg';
    img.style = 'width: 120px; height: 120px;';

    super(scene, x, y, img);

    scene.add.existing(this);
    this.setOrigin(0.5, 0.5);
  }
}

// Container approach
export default class CharacterVectors extends Phaser.GameObjects.Container {
  constructor({ scene, x, y }) {
    super(scene, x, y);

    this.setSize(240, 300);

    this._body = new Body(scene, 0, 80);
    this._head = new Head(scene, 0, -30);
    this.add([this._body, this._head]);
    
    scene.add.existing(this);

    scene.physics.world.enable(this);
    this.body.setCollideWorldBounds(true);
  }

  move({ direction = 'right', speed = 200 } = {}) {
    const factor = direction === 'right' ? 1 : -1;
    if (direction !== 'right') {
      this.each(entity => entity.setFlipX(true));
    }
    this.body.setVelocityX(factor * speed);
  }

  stop() {
    this.body.setVelocity(0, 0);
  }

  revealFace(mode = 'instant') {
    if (mode === 'instant') {
      this.remove(this._head);
      this._head = new Face(this.scene, 20, -30);
      this.add(this._head);
    }

    if (mode === 'fall') {
      this.remove(this._head);
      this._head = new Face(this.scene, 20, -30);
      this.add(this._head);
      const fallingHead = new Head(this.scene, this.x, this.y - 30);
      fallingHead.fall();
    }
  }

  looseHead() {
    this.remove(this._head);
    const lostHead = new Head(this.scene, this.x, this.y - 30);
    lostHead.fall();
  }
}

export function preload() {
  this.load.image(`character_body`, `CharacterVectors/Body.png`);
  this.load.image(`character_head`, `CharacterVectors/Head.png`);
}
